/**
 * Sözleşme sayfalarının adresleri — TEK yer (CLOS-102 `[063]`).
 *
 * ### Neden şimdi ve neden burada
 *
 * Bekleyen İşlemler paneli bir öğeye tıklandığında ilgili sözleşmeye yönlendirmek zorunda
 * (kartın kriteri). Adresi panelin içine gömmek, sözleşme ekranları geldiğinde (`[069]`+,
 * EP08 versiyonlama) düzeltilecek ikinci bir kopya doğururdu.
 *
 * ⚠ Sayfalar ARTIK VAR (`router.tsx`, sözleşme detayının beş bölümü). Bu yorum bir süre
 * "sayfalar henüz yok" diyordu ve doğru değildi; adres üretimi tek yerde kaldığı için
 * sayfalar açılırken yalnız bu dosya güncellendi — kurulduğu amacı karşıladı.
 */

const KOK = "/app/sozlesmeler";

/**
 * Sözleşmenin adresi. `versionId` verilirse DEĞİŞMEZ versiyonun adresi.
 *
 * İmza ve onay görevleri versiyona bağlı: hangi metnin imzalandığı sözleşmenin güncel
 * hâlinden bağımsız bir gerçek. Kullanıcıyı güncel hâle götürmek, başka bir metni
 * imzalatmak olurdu.
 */
export function contractPath(contractId: string, versionId?: string | null): string {
  return versionId ? `${KOK}/${contractId}/versiyonlar/${versionId}` : `${KOK}/${contractId}`;
}

/**
 * BEKLEYEN İŞİN adresi — sözleşme başka çalışma alanına aitse PAYLAŞILAN yüzey (CLOS-1195).
 *
 * ⚠ Kiracılar arası mutabakat/imza görevinde kişinin kanonik yüzeyi sahibin sözleşme
 * sayfası DEĞİL. Ölçüldü: görev panelde görünüyor, tıklanınca "Versiyon bulunamadı · Bu
 * versiyon yok ya da erişiminiz bulunmuyor" çıkıyordu — iki ayrı kullanıcıda.
 *
 * ⚠ Paylaşılan yüzeyde VERSİYON rotası yok: o yüzey sözleşmenin tamamını tek sayfada
 * gösteriyor ve karşı tarafa hangi sürümün paylaşıldığını kendisi söylüyor. Versiyon
 * kimliğini oraya iliştirmek, olmayan bir sayfaya götürmek olurdu.
 */
export function pendingTaskPath(gorev: {
  contractId: string;
  contractVersionId: string | null;
  shared: boolean;
}): string {
  return gorev.shared
    ? `${KOK}/paylasilanlar/${gorev.contractId}`
    : contractPath(gorev.contractId, gorev.contractVersionId);
}
